import _ from "lodash";
import { createAction, RSAARequestType, RSAASuccessType, RSAAFailureType } from "redux-api-middleware";
import decamelizeKeysDeep from "decamelize-keys-deep";
import AppSettings from "../config";
import networkSelectors from "../selectors/network";

export const PUT_EMPLOYEE_LOADING = "PUT_EMPLOYEE_LOADING";
export const PUT_EMPLOYEE_SUCCESS = "PUT_EMPLOYEE_SUCCESS";
export const PUT_EMPLOYEE_FAILURE = "PUT_EMPLOYEE_FAILURE";
export const PUT_EMPLOYEE_CLEAR = "PUT_EMPLOYEE_CLEAR";

export const PUT_EMPLOYEE_CRM_PERMISSIONS_LOADING = "PUT_EMPLOYEE_CRM_PERMISSIONS_LOADING";
export const PUT_EMPLOYEE_CRM_PERMISSIONS_SUCCESS = "PUT_EMPLOYEE_CRM_PERMISSIONS_SUCCESS";
export const PUT_EMPLOYEE_CRM_PERMISSIONS_FAILURE = "PUT_EMPLOYEE_CRM_PERMISSIONS_FAILURE";
export const PUT_EMPLOYEE_CRM_PERMISSIONS_CLEAR = "PUT_EMPLOYEE_CRM_PERMISSIONS_CLEAR";

export const PUT_EMPLOYEE_CE_PERMISSIONS_LOADING = "PUT_EMPLOYEE_CE_PERMISSIONS_LOADING";
export const PUT_EMPLOYEE_CE_PERMISSIONS_SUCCESS = "PUT_EMPLOYEE_CE_PERMISSIONS_SUCCESS";
export const PUT_EMPLOYEE_CE_PERMISSIONS_FAILURE = "PUT_EMPLOYEE_CE_PERMISSIONS_FAILURE";
export const PUT_EMPLOYEE_CE_PERMISSIONS_CLEAR = "PUT_EMPLOYEE_CE_PERMISSIONS_CLEAR";

export const POST_EMPLOYEE_LOADING = "POST_EMPLOYEE_LOADING";
export const POST_EMPLOYEE_SUCCESS = "POST_EMPLOYEE_SUCCESS";
export const POST_EMPLOYEE_FAILURE = "POST_EMPLOYEE_FAILURE";
export const POST_EMPLOYEE_CLEAR = "POST_EMPLOYEE_CLEAR";

export const EMPLOYEES_LIST_QUERY_KEY = "employees" as const;

export function putEmployee(id: string, body: any) {
  return createAction({
    endpoint: `${AppSettings.EMPLOYEES_API_URL}/${id}`,
    method: "PUT",
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
    headers: networkSelectors.defaultHeaders,
    types: _.map([PUT_EMPLOYEE_LOADING, PUT_EMPLOYEE_SUCCESS, PUT_EMPLOYEE_FAILURE], (type) => ({
      type,
      meta: { id },
    })) as [RSAARequestType, RSAASuccessType, RSAAFailureType],
  });
}

export function putEmployeeCrmPermissions(id: string, body: any) {
  return createAction({
    endpoint: `${AppSettings.EMPLOYEES_API_URL}/${id}/crm_permissions`,
    method: "PUT",
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
    headers: networkSelectors.defaultHeaders,
    types: _.map(
      [
        PUT_EMPLOYEE_CRM_PERMISSIONS_LOADING,
        PUT_EMPLOYEE_CRM_PERMISSIONS_SUCCESS,
        PUT_EMPLOYEE_CRM_PERMISSIONS_FAILURE,
      ],
      (type) => ({ type, meta: { id } }),
    ) as [RSAARequestType, RSAASuccessType, RSAAFailureType],
  });
}

export function putEmployeeCrmPermissionsClear(id: string) {
  return (dispatch: any) =>
    dispatch({
      type: PUT_EMPLOYEE_CRM_PERMISSIONS_CLEAR,
      meta: { id },
    });
}

export function putEmployeeCePermissions(id: string, body: any) {
  return createAction({
    endpoint: `${AppSettings.EMPLOYEES_API_URL}/${id}/ce_permissions`,
    method: "PUT",
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
    headers: networkSelectors.defaultHeaders,
    types: _.map(
      [PUT_EMPLOYEE_CE_PERMISSIONS_LOADING, PUT_EMPLOYEE_CE_PERMISSIONS_SUCCESS, PUT_EMPLOYEE_CE_PERMISSIONS_FAILURE],
      (type) => ({ type, meta: { id } }),
    ) as [RSAARequestType, RSAASuccessType, RSAAFailureType],
  });
}

export function putEmployeeCePermissionsClear(id: string) {
  return (dispatch: any) =>
    dispatch({
      type: PUT_EMPLOYEE_CE_PERMISSIONS_CLEAR,
      meta: { id },
    });
}

export function putEmployeeClear(id: string) {
  return (dispatch: any) =>
    dispatch({
      type: PUT_EMPLOYEE_CLEAR,
      meta: { id },
    });
}

export function postEmployee(body: any) {
  return createAction({
    endpoint: `${AppSettings.EMPLOYEES_API_URL}`,
    method: "POST",
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
    headers: networkSelectors.defaultHeaders,
    types: [POST_EMPLOYEE_LOADING, POST_EMPLOYEE_SUCCESS, POST_EMPLOYEE_FAILURE],
  });
}

export function postEmployeeClear() {
  return (dispatch: any) =>
    dispatch({
      type: POST_EMPLOYEE_CLEAR,
    });
}
